<script>
    import R, {LOADER} from "../lib/requests";
    import PageHeader from "../components/PageHeader.svelte";
    import Checkbox from "../components/controls/Checkbox.svelte";

    let reportFields = [];
    let reportLink = null;


    const initialize = () => {
        const onSuccess = result => {
            reportFields = result.fields;
            reportFields.map(item => {
                item.selected = 1;
            });
        }

        const onFailure = err => {
        };

        R.handle(R.report.initialize, [], onSuccess, onFailure, LOADER.PAGE);
    }


    const exportReport = () => {
        const onSuccess = result => {
            reportLink = result.link;
        }

        const onFailure = err => {
        };

        let fields = [];
        reportFields.map(item => {
            if (item.selected) {
                fields.push(item.id);
            }
        })

        reportLink = null;
        R.handle(R.report.export, {fields}, onSuccess, onFailure, LOADER.POPUP);
    }

    initialize();
</script>

<PageHeader title="Αναφορές"/>
<div class="row">
    <div class="col-xl-3">
        <div class="panel-simple panel-pad">
            <p>
                Επιλέξτε πεδία για την συλλογή στοιχείων
            </p>
            {#if reportFields}
                {#each reportFields as field}
                    <Checkbox label="{field.name}" bind:checked="{field.selected}" cssClass="mb-2"/>
                {/each}
            {/if}

            <button class="btn btn-primary btn-block mt-4" on:click="{exportReport}">Εξαγωγή</button>
        </div>
    </div>
    <div class="col-xl-7">
        {#if reportLink}
            <div class="panel-simple panel-pad">
                <h5>Η εξαγωγή ολοκληρώθηκε.</h5>
                <p>
                    Αρχείο εξαγωγής:<br>
                    <a href="{ reportLink }" target="_blank">{ reportLink }</a>
                </p>
            </div>
        {/if}
    </div>
</div>